import { Router } from '@angular/router';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import * as i0 from "@angular/core";
import * as i1 from "../../environment/services/environment.configuration";
import * as i2 from "@angular/router";
/** Stops the Annual Plan V2 chunk from loading, even by URL, wherever `features.annualPlanV2` is off. */
var AnnualPlanFeatureFlagGuard = /** @class */ (function () {
    function AnnualPlanFeatureFlagGuard(environment, router) {
        this.environment = environment;
        this.router = router;
    }
    AnnualPlanFeatureFlagGuard.prototype.canLoad = function () {
        if (this.environment.features && this.environment.features.annualPlanV2) {
            return true;
        }
        this.router.navigate(['/annual-plan-home']);
        return false;
    };
    AnnualPlanFeatureFlagGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnnualPlanFeatureFlagGuard_Factory() { return new AnnualPlanFeatureFlagGuard(i0.ɵɵinject(i1.EnvironmentConfiguration), i0.ɵɵinject(i2.Router)); }, token: AnnualPlanFeatureFlagGuard, providedIn: "root" });
    return AnnualPlanFeatureFlagGuard;
}());
export { AnnualPlanFeatureFlagGuard };
